// What deleting each type of record does to related records, in user-facing terms. Shown in the
// bulk delete confirmation. Keep in sync with the API's model observers and foreign key cascades.
const REMOVE_AS_MASTER_OWNER = 'Remove them as a master owner on any audio files. The remaining owners\' splits are recalculated.'

export default {
  albums: {
    alsoWill: [
      'Remove them from any releases.'
    ]
  },

  artists: {
    alsoWill: [
      REMOVE_AS_MASTER_OWNER,
      'Remove them from any cuts they\'re on, as an artist or featured artist.',
      'Remove them as "Pitched For" on pitches and playlists, and from any holds.'
    ]
  },

  contacts: {
    alsoWill: [
      REMOVE_AS_MASTER_OWNER,
      'Remove them as a producer on any cuts.',
      'Remove them wherever they\'re listed as a contact, such as "Pitched To" on pitches and playlists.'
    ]
  },

  projects: {
    alsoWill: [
      'Permanently delete every sync on these projects.'
    ]
  },

  publishingCompanies: {
    alsoWill: [
      REMOVE_AS_MASTER_OWNER,
      'Remove them as a shareholder on any songwriter contracts.'
    ]
  },

  recordLabels: {
    alsoWill: [
      REMOVE_AS_MASTER_OWNER,
      'Remove them from any releases.'
    ]
  }
}
